/**
 * Utility to fix unread message counts and prevent double-counting
 */

// Store rooms that have been viewed
let viewedRooms = new Set();

// Function to initialize from localStorage
function initViewedRooms() {
  try {
    const stored = localStorage.getItem('chat_viewed_rooms');
    if (stored) {
      const parsed = JSON.parse(stored);
      viewedRooms = new Set(parsed);
    }
  } catch (e) {
    console.error('Error loading viewed rooms:', e);
    viewedRooms = new Set();
  }
}

// Function to save to localStorage
function saveViewedRooms() {
  localStorage.setItem('chat_viewed_rooms', JSON.stringify([...viewedRooms]));
}

// Mark a room as viewed
function markRoomViewed(roomId) {
  if (!viewedRooms.has(roomId)) {
    viewedRooms.add(roomId);
    saveViewedRooms();
  }
}

// Check if a room has been viewed
function hasRoomBeenViewed(roomId) {
  return viewedRooms.has(roomId);
}

// Reset viewed rooms
function resetViewedRooms() {
  viewedRooms.clear();
  saveViewedRooms();
}

// Recalculate unread count from actual room states
function recalculateUnreadCount(chatRooms) {
  let count = 0;
  
  if (chatRooms && chatRooms.length) {
    for (const room of chatRooms) {
      if (room[1] && !room[1].profile.is_read && !viewedRooms.has(room[0])) {
        count++;
      }
    }
  }
  
  // Update the UI count
  frappe.Chat.settings.unread_count = count;
  
  if (count > 0) {
    $('#chat-notification-count').text(count);
  } else {
    $('#chat-notification-count').text('');
  }
  
  return count;
}

// Initialize the module
function init() {
  initViewedRooms();
}

export {
  init,
  markRoomViewed,
  hasRoomBeenViewed,
  resetViewedRooms,
  recalculateUnreadCount
}; 